import type { DeepLink_ConfigFragment } from '~/graphql/types';
import generateDeepLinkKey from '../generateDeepLinkKey';
import type { OptionOf } from '~/components/molecule/Dropdown';

type SelectedDeepLinkOptionArgs = {
  type: string | undefined;
  typeId: string | null | undefined;
};

/**
 * Returns the selected deep link option based on the type and typeId
 * @param {Array<OptionOf<DeepLink_ConfigFragment>>} configOptions - The options to search through
 * @param {SelectedDeepLinkOptionArgs} args - The arguments to search for
 * @returns {OptionOf<DeepLink_ConfigFragment> | undefined} The selected deep link option
 */
const getSelectedDeepLinkOption = (
  configOptions: Array<OptionOf<DeepLink_ConfigFragment>> = [],
  { type, typeId }: SelectedDeepLinkOptionArgs,
): OptionOf<DeepLink_ConfigFragment> | undefined =>
  configOptions.find(
    option => option.key === generateDeepLinkKey(type, typeId),
  );

export default getSelectedDeepLinkOption;
